import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="section-container max-w-4xl">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            关于我们
          </h2>
          <p className="text-sm text-foreground-500 mt-1">了解天狼影院的初心与坚持</p>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200">
          <div className="flex flex-col gap-5">
            {aboutData.paragraphs.map((paragraph, index) => (
              <p
                key={index}
                className="text-sm md:text-base text-foreground-700 leading-relaxed"
              >
                {paragraph}
              </p>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-6 md:gap-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">50,000+</div>
              <div className="text-xs text-foreground-500 mt-1">海量剧集</div>
            </div>
            <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">2018</div>
              <div className="text-xs text-foreground-500 mt-1">创立年份</div>
            </div>
            <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-secondary-500">1亿+</div>
              <div className="text-xs text-foreground-500 mt-1">累计用户</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}